export enum OfferType {
  Targeted = 'targeted',
  Push = 'push',
  Random = 'random',
  Automatic = 'automatic',
  Initiative = 'initiative',
}

export const OFFER_TYPE_I18N = {
  [OfferType.Automatic]: 'Automatic',
  [OfferType.Push]: 'Push',
  [OfferType.Random]: 'Random',
  [OfferType.Targeted]: 'Targeted',
  [OfferType.Initiative]: 'Initiativ',
};
